import { AutoComplete } from "antd";
import React from "react";

interface Props {
  value: string;
  onChange: (val: string) => void;
  suggestions: string[];
  placeholder?: string;
  style?: React.CSSProperties;
}

export function AutocompleteInput({ value, onChange, suggestions, placeholder, style }: Props) {
  const options = [...new Set(suggestions.filter(Boolean))].map((s) => ({ value: s }));
  return (
    <AutoComplete
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      style={{ minWidth: 120, ...style }}
      filterOption={(input, option) =>
        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
}
